import * as React from "react";
import { Card } from "antd";
import { ProviderAWS } from "./aws";
import { ProviderAzure } from "./azure";
import { ProviderGCP } from "./gcp";
import { ProviderNGS } from "./ngs";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";

export const Provider: React.FC = () => {
  const provider = useCpFormValue("provider");

  return (
    <div className="cpln-form-section cpln-ant-card-container">
      <Card>
        {provider === "aws" ? <ProviderAWS /> : null}
        {provider === "azure" ? <ProviderAzure /> : null}
        {provider === "gcp" ? <ProviderGCP /> : null}
        {provider === "ngs" ? <ProviderNGS /> : null}
      </Card>
    </div>
  );
};
